import { Component, forwardRef, OnChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ProductSectionHeaderComponent } from '../product-section-header/product-section-header.component';
import { CompanyDomainModel } from '../../../../../../../../domain/company-domain-model';

@Component({
  selector: 'app-come-to-bask-section-header',
  templateUrl: './come-to-bask-section-header.component.html',
  providers: [
    { provide: ProductSectionHeaderComponent, useExisting: forwardRef(() => ComeToBaskSectionHeaderComponent) }
  ],
  standalone: false
})
export class ComeToBaskSectionHeaderComponent extends ProductSectionHeaderComponent implements OnChanges {
  constructor(companyDomainModel: CompanyDomainModel, sanitizer: DomSanitizer) {
    super(companyDomainModel, sanitizer);
  }
}
